import { UserType, useLastSeen } from '@gopeerproject/chuck';
import React, { useMemo } from 'react';
import { Image, TouchableOpacity, View } from 'react-native';
import { useStyleSheet, useThemeContext } from '../../hooks';
import { createStyleSheet } from '../../utils';
import { Text } from '../Text';
export const User = ({ name, image, type, online, lastSeen, onPress, size, badgeOutlineColor, style }) => {
    const styles = useStyleSheet(getStyles);
    const lastSeenText = useLastSeen(lastSeen ? new Date(lastSeen) : undefined);
    const { onlineBadgePosition, lastSeenBadgePosition } = useMemo(() => {
        switch (size) {
            case 'sm':
                return {
                    onlineBadgePosition: {
                        bottom: -3,
                        right: -4
                    },
                    lastSeenBadgePosition: {
                        bottom: -3,
                        right: -3
                    }
                };
            case 'md':
                return {
                    onlineBadgePosition: {
                        bottom: -3,
                        right: -2
                    },
                    lastSeenBadgePosition: {
                        bottom: -3,
                        right: -3
                    }
                };
            case 'lg':
                return {
                    onlineBadgePosition: {
                        bottom: -3,
                        right: 5
                    },
                    lastSeenBadgePosition: {
                        bottom: -3,
                        right: -3
                    }
                };
            case 'xl':
                return {
                    onlineBadgePosition: {
                        bottom: -3,
                        right: 10
                    },
                    lastSeenBadgePosition: {
                        bottom: -3,
                        right: -3
                    }
                };
            case 'xxl':
                return {
                    onlineBadgePosition: {
                        bottom: 0,
                        right: 15
                    },
                    lastSeenBadgePosition: {
                        bottom: 0,
                        right: 5
                    }
                };
            case 'xxxl':
                return {
                    onlineBadgePosition: {
                        bottom: 5,
                        right: 15
                    },
                    lastSeenBadgePosition: {
                        bottom: 5,
                        right: 7
                    }
                };
        }
    }, [size]);
    return (React.createElement(View, { style: style },
        onPress ? (React.createElement(TouchableOpacity, { onPress: onPress },
            React.createElement(UserAvatar, { type: type, name: name, size: size, image: image }))) : (React.createElement(View, null,
            React.createElement(UserAvatar, { type: type, name: name, size: size, image: image }))),
        online ? (React.createElement(View, { style: [
                styles.online,
                onlineBadgePosition,
                badgeOutlineColor ? { backgroundColor: badgeOutlineColor } : {}
            ] },
            React.createElement(View, { style: styles.onlineDot }))) : lastSeenText ? (React.createElement(View, { style: [
                styles.lastSeen,
                lastSeenBadgePosition,
                badgeOutlineColor ? { borderColor: badgeOutlineColor } : {}
            ] },
            React.createElement(View, { style: styles.lastSeenWrapper },
                React.createElement(Text, { type: 'body', size: 'sm', weight: 'regular', style: styles.lastSeenText }, lastSeenText)))) : null));
};
const UserAvatar = ({ type, image, size, name }) => {
    const styles = useStyleSheet(getStyles);
    const { color } = useThemeContext();
    const { backgroundColor, textColor } = useMemo(() => {
        switch (type) {
            case UserType.PARENT:
                return {
                    backgroundColor: color.parent.ghost,
                    textColor: color.parent.solid
                };
            case UserType.STUDENT:
                return {
                    backgroundColor: color.primary.ghost,
                    textColor: color.primary.solid
                };
            case UserType.ADMIN:
            case UserType.TUTOR:
            default:
                return {
                    backgroundColor: color.success.ghost,
                    textColor: color.success.solid
                };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);
    if (image) {
        return (React.createElement(Image, { source: {
                uri: image
            }, style: [styles.wrapper, styles[size]] }));
    }
    return (React.createElement(View, { style: [{ backgroundColor }, styles.wrapper, styles[size]] },
        React.createElement(Text, { type: 'body', size: 'md', weight: 'semibold', style: { color: textColor } }, `${name.charAt(0).toUpperCase()}${name.charAt(1)}`)));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    wrapper: {
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 9999
    },
    sm: {
        width: size.K,
        height: size.K
    },
    md: { width: size.M, height: size.M },
    lg: { width: size.N, height: size.N },
    xl: { width: size.O, height: size.O },
    xxl: { width: size.P, height: size.P },
    xxxl: { width: size.P + size.K, height: size.P + size.K },
    online: {
        width: size.F,
        height: size.F,
        borderRadius: size.F,
        position: 'absolute',
        backgroundColor: color.bg.v1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    onlineDot: {
        width: size.D,
        height: size.D,
        backgroundColor: color.success.solid,
        borderRadius: size.D
    },
    lastSeen: {
        height: size.G,
        borderRadius: size.G,
        borderWidth: 3,
        borderColor: color.bg.v1,
        position: 'absolute',
        backgroundColor: color.bg.v1
    },
    lastSeenWrapper: {
        width: size.J,
        height: size.D,
        backgroundColor: color.success.ghost,
        borderRadius: size.D,
        alignItems: 'center',
        justifyContent: 'center'
    },
    lastSeenText: {
        color: color.success.solid,
        fontSize: 9
    }
}));
//# sourceMappingURL=index.js.map